module.exports = __webpack_public_path__ + "img/chihewanle.ccf8a5b4.png";